import { useEffect } from "react"

/*
 * Calls callback in an effect and renders children
 */
export function FireCallbackInEffect({ children, callback }) {
  useEffect(() => {
    callback()
  })

  return children
}
